import { useEffect, useState } from "react";
import {
	Command,
} from "../../components/ui/command";
import { Input } from "../../components/ui/input";
import { ScrollArea } from "../../components/ui/scrollarea";

interface TypesMultiselect {
	data: any;
	onSelectChange?: (selected: string[]) => void;
	CurrentSelected: any
}

const Tags: React.FC<TypesMultiselect> = ({
	data,
	onSelectChange,
	CurrentSelected,
}) => {
	const [selected, setSelected] = useState<string[]>([]);

	useEffect(() => {
		if (CurrentSelected) {
			setSelected(CurrentSelected)
		}
	}, [])


	const toggleOption = (value: string) => {
		setSelected((prev) => {
			const newSelected = prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value];
			if (onSelectChange) {
				onSelectChange(newSelected); // Chamando a função de callback
			}
			return newSelected;
		});
	};

	const [pesquisa, setPesquisa] = useState("");

	const resultadosFiltrados = data.filter((etiqueta: any) =>
		etiqueta.label.toLowerCase().includes(pesquisa.toLowerCase())
	);

	return (
		<Command className="rounded-lg  bg-white md:min-w-[300px]" style={{}}>
			<Input
				type="text"
				value={pesquisa}
				onChange={(e) => setPesquisa(e.target.value)}
				placeholder="Pesquisar etiqueta"
				className=""
			/>
			<div className="flex flex-wrap gap-4 w-full mt-5">
				<ScrollArea className="h-[150px] w-[100%]">
					{resultadosFiltrados.map((etiqueta: any, index: number) => {
						if (selected.includes(etiqueta.value)) {
							return (
								<button
									key={index}
									onClick={() => { toggleOption(etiqueta.value) }}
									style={{
										backgroundColor: selected.includes(etiqueta.value) ? "#00A377" : "#CEF6E7",
										borderRadius: "30px",
										padding: "0.7rem",
										margin: "0.3rem",
										color: "#000E4B",
										fontFamily: "NotoSans-Regular",
										fontWeight: "600",
										fontSize: "12px",
										letterSpacing: "0%",
										textAlign: "center",
										verticalAlign: "middle",
									}}
								>
									{etiqueta.label}
								</button>
							)
						}

					})}
					{resultadosFiltrados.map((etiqueta: any, index: number) => {
						if (!selected.includes(etiqueta.value)) {
							return (
								<button
									key={index}
									onClick={() => { toggleOption(etiqueta.value) }}
									style={{
										backgroundColor: selected.includes(etiqueta.value) ? "#00A377" : "#CEF6E7",
										borderRadius: "30px",
										padding: "0.7rem",
										margin: "0.3rem",
										color: "#000E4B",
										fontFamily: "NotoSans-Regular",
										fontWeight: "600",
										fontSize: "12px",
										letterSpacing: "0%",
										textAlign: "center",
										verticalAlign: "middle",
									}}
								>
									{etiqueta.label}
								</button>
							)
						}

					})}
				</ScrollArea>
			</div>
		</Command>
	);
};

export default Tags;
